import Freeplay from './freeplay';
import DepositBoost from './deposit-boost';

export default {
    Freeplay,
    DepositBoost
}